<template>
  <b-modal
    id="send-book-to-kindle-modal"
    :modal-class="modalClasses"
    :hide-footer="true"
    ref="selectBookCreation"
    @shown="shown"
    @hidden="hidden"
  >
    <template v-slot:modal-title>
      Enviar para Kindle
    </template>

    <template v-slot:default>
      <AlertWraper
        :content="errors"
        type="error"
      />
      <div class="text-center">
        <div class="font-size-small">
          <p>
            Para enviar o livro <span class="font-weight-bold text-color2">{{ book.title }}</span> para o seu Kindle é muito fácil!
          </p>
          <p>
            Cada Kindle vem com um endereço de email exclusivo e a Amazon permite que nós façamos o envio do livro direto para o seu aparelho!
          </p>
          <p v-if="!user.kindle_email">
            Dessa forma, vamos precisar do endereço de email para o seu Kindle. Mas não se preocupe, você só precisa fazer esse processo uma vez e nós salvaremos para as próximas vezes!
          </p>
          <p>Lembre-se, esse e-mail é o que possui o final @kindle.com.</p>
          <p>
            <strong>Importante:</strong> pode demorar até <strong>48 horas</strong> para que o livro esteja disponível no seu Kindle.
          </p>

          <form class="default-form mt-4 position-relative" @submit.prevent="submit">
            <div>
              <div class="form-group default-input">
                <input type="text" class="form-control with-label" v-model.trim="$v.form.email.$model" placeholder="" />
                <label>E-mail Kindle</label>
              </div>
              <p class="text-left">
                Não sabe o endereço de e-mail? <span class="link-color2 font-weight-bold cursor-pointer" @click="isInstructionsOpen = true">Clique aqui</span> e siga as instruções.
              </p>

              <div class="text-left" v-if="isInstructionsOpen">
                <div class="text-center mb-3">
                  <Button
                    class="btn-outline-color2 btn-sm"
                    type="button"
                    @click="isInstructionsOpen = false"
                  >
                    Esconder instruções
                  </Button>
                </div>
                <h3 class="font-size-regular text-color2 font-weight-bold">Abra as Configurações no Kindle</h3>
                <p>
                  Desbloqueie o seu Kindle ao apertar o botão embaixo do aparelho. Uma vez na tela inicial, <strong>deslize o dedo para baixo no topo da tela</strong> e então <strong>clique em "Todas as Configurações"</strong>.
                </p>
                <div class="text-center">
                  <img src="/images/pages/kindle/kindle-email-1.jpg" alt="Abra todas as configurações" />
                </div>
                <h3 class="font-size-regular text-color2 font-weight-bold mt-4">Entre nas informações gerais da conta</h3>
                <p>
                  Uma vez no menu de configurações, <strong>clique em "Sua Conta"</strong>.
                </p>
                <div class="text-center">
                  <img src="/images/pages/kindle/kindle-email-2.jpg" alt="Abra as informações da conta" />
                </div>
                <h3 class="font-size-regular text-color2 font-weight-bold">Copie o endereço de e-mail do Kindle</h3>
                <p>
                  No <strong>final da lista</strong> você verá o seu <strong>endereço de e-mail do Kindle</strong>, terminando em @kindle.com. <strong>Esse é o endereço que precisamos</strong>.
                </p>
                <div class="text-center">
                  <img src="/images/pages/kindle/kindle-email-3.jpg" alt="Copie o endereço" />
                </div>
                <div class="text-center mb-3">
                  <Button
                    class="btn-outline-color2 btn-sm"
                    type="button"
                    @click="isInstructionsOpen = false"
                  >
                    Esconder instruções
                  </Button>
                </div>
              </div>
            </div>
            <div class="mt-3">
              <Button
                class="btn-primary btn-sm"
                type="submit"
                :loading="loader"
                :disabled="$v.$invalid"
              >
                Enviar para Kindle
              </Button>
            </div>
          </form>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>

import BooksService from '@/modules/books/services/books-service'
import NotificationService from '@/modules/notifications/services/notifications-service'
import { required } from 'vuelidate/lib/validators'
import { parseErrorResponseToArray } from '@/utils'
import { mapState } from 'vuex'

import AlertWraper from '@/components/common/Alert/AlertWraper.vue'
import Button from '@/components/common/Button/Button.vue'

export default {
  name: 'SendBookToKindleModal',
  props: ['book'],
  components: {
    AlertWraper,
    Button
  },
  data () {
    return {
      errors: null,
      form: {
        book_id: '',
        email: ''
      },
      isInstructionsOpen: false,
      loader: false
    }
  },
  validations () {
    return {
      form: {
        book_id: { required },
        email: { required }
      }
    }
  },
  computed: {
    ...mapState('users', {
      user: state => state.user
    }),
    ...mapState({
      nightMode: state => state.nightMode
    }),
    modalClasses () {
      return {
        'default-modal': true
      }
    }
  },
  methods: {
    /**
     * On hidden modal
     */
    hidden () {
      this.reset()
    },
    /**
     * Reset variables
     */
    reset () {
      this.errors = null
    },
    /**
     * Submit and request epub be sent to kindle
     */
    async submit () {
      this.loader = true
      try {
        await BooksService.sendBookToKindle({
          id: this.form.book_id,
          email: this.form.email
        })
        this.$bvModal.hide('send-book-to-kindle-modal')
        const notification = {
          notification: {
            type: 'success',
            content: 'Solicitação de envio gerada com sucesso'
          }
        }
        NotificationService.createGlobalSuccessNotification(notification)
      } catch (error) {
        this.errors = parseErrorResponseToArray(error)
      }
      this.loader = false
    },
    /**
     * On shown modal
     */
    shown () {
      this.form.book_id = this.book.id
      if (this.user.kindle_email) this.form.email = this.user.kindle_email
    }
  }
}
</script>
